import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    tooltip: {
        backgroundColor: `color-mix(in srgb, var(--brand-025) 30%, transparent)`,
        color: 'var(--brand-700)',
        fontSize: '1rem',
        fontWeight: 'bolder',
        padding: '0.6rem 2rem',
        boxShadow: `0 4px 30px color-mix(in srgb, var(--grey-900) 10%, transparent)`,
        backdropFilter: 'blur(3px)',
        border: `1px solid color-mix(in srgb, var(--info-500) 13%, transparent)`,
    },
});

const SideTooltip = ({ classes, title, menuItems, children }) => {

    return (
        <>
            <Tooltip
                title={title}
                classes={{ tooltip: classes?.tooltip }}
                placement='right'
                PopperProps={{
                    popperOptions: {
                        modifiers: {
                            offset: {
                                enabled: true,
                                offset: '0, 10rem',
                            },
                        },
                    },
                }}
            >
                {children}
            </Tooltip>
        </>
    );
};

export default withStyles(styles)(SideTooltip);
